var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSearch()
            },
          },
        },
        [
          !_vm.readOnly && _vm.autorizado
            ? _c(
                "b-input-group",
                { staticClass: "mt-5 mb-3 w-25" },
                [
                  _c("b-form-input", {
                    ref: "searchInput",
                    attrs: {
                      placeholder: _vm.$t("global.process.search.action"),
                      disabled: _vm.habilitarCvu,
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-3",
                          attrs: {
                            size: "sm",
                            variant: "primary",
                            type: "submit",
                            disabled: _vm.habilitarCvu,
                          },
                        },
                        [
                          _c("strong", { staticClass: "ml-2" }, [
                            _vm._v(
                              _vm._s(_vm.$t("global.process.search.action"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-icon", {
                            staticClass: "ml-2",
                            attrs: { icon: "search" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSearch()
            },
          },
        },
        [
          !_vm.readOnly && _vm.autorizado
            ? _c(
                "b-input-group",
                { staticClass: "mt-5 mb-3 w-35" },
                [
                  _c("b-form-input", {
                    attrs: {
                      placeholder: "Nombre(s)",
                      disabled: _vm.habilitarNombreApellido,
                    },
                    model: {
                      value: _vm.nombre,
                      callback: function ($$v) {
                        _vm.nombre = $$v
                      },
                      expression: "nombre",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      placeholder: "Primer Apellido",
                      disabled: _vm.habilitarNombreApellido,
                    },
                    model: {
                      value: _vm.primerApellido,
                      callback: function ($$v) {
                        _vm.primerApellido = $$v
                      },
                      expression: "primerApellido",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      placeholder: "Segundo Apellido",
                      disabled: _vm.habilitarNombreApellido,
                    },
                    model: {
                      value: _vm.segundoApellido,
                      callback: function ($$v) {
                        _vm.segundoApellido = $$v
                      },
                      expression: "segundoApellido",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-3",
                          attrs: {
                            size: "sm",
                            variant: "primary",
                            type: "submit",
                            disabled: _vm.habilitarNombreApellido,
                          },
                        },
                        [
                          _c("strong", { staticClass: "ml-2" }, [
                            _vm._v(
                              _vm._s(_vm.$t("global.process.search.action"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-icon", {
                            staticClass: "ml-2",
                            attrs: { icon: "search" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _vm.expedientesEncontrados.length > 0
                ? _c("message", {
                    attrs: {
                      variant: _vm.variant,
                      title: "Expedientes encontrados",
                      description: _vm.mensajeExpedientes,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.expedientesEncontrados.length > 0
            ? _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    { staticClass: "card-body bg-light mb-3" },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.collapse-expedientes",
                              modifiers: { "collapse-expedientes": true },
                            },
                          ],
                          staticClass: "mb-2",
                          attrs: { variant: "primary", size: "sm" },
                        },
                        [
                          _c("strong", { staticClass: "ml-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Ocultar o mostrar los expedientes encontrados"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "collapse-expedientes", visible: "" } },
                        [
                          _c("b-table", {
                            attrs: {
                              "sticky-header": "500px",
                              fields: _vm.expedientes,
                              items: _vm.expedientesEncontrados,
                              "thead-class": "custom-header",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(accion)",
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "b-button-group",
                                        { attrs: { size: "sm" } },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.right",
                                                  value: _vm.$t(
                                                    "global.process.search.verExpediente"
                                                  ),
                                                  expression:
                                                    "$t('global.process.search.verExpediente')",
                                                  modifiers: {
                                                    hover: true,
                                                    right: true,
                                                  },
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.seleccionarExpediente(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                attrs: { icon: "eye" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3215729676
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-overlay", { attrs: { show: _vm.isSearching } }, [
        _vm.expediente
          ? _c(
              "div",
              [
                _vm.showSection("datos-generales")
                  ? _c("datos-generales", {
                      attrs: {
                        visible: _vm.visible,
                        item: _vm.expediente,
                        misAyudantes: _vm.misAyudantes,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("vigencias")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.vigencias.sni.title"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.vigenciasSni &&
                                _vm.expediente.vigenciasSni.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelVigencias()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.expediente.vigenciasSni &&
                                _vm.expediente.vigenciasSni.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-danger",
                                          disabled: _vm.botonPdfDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.generarVisualizarPdfVigencias()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "file-earmark-pdf" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.GenerarPdf")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("vigencias-sni", {
                          attrs: { item: _vm.expediente.vigenciasSni },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("excepcionesInvestigador")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.excepciones.title"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.excepcionesInvestigador &&
                                _vm.expediente.excepcionesInvestigador.length >
                                  0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelExcepciones()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("excepciones", {
                          attrs: {
                            excepcionesInvestigador:
                              _vm.expediente.excepcionesInvestigador,
                          },
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.adeudos &&
                                _vm.expediente.adeudos > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelAdeudos()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("adeudos", {
                          attrs: {
                            expediente: _vm.expediente,
                            noTieneAdeudo: _vm.noTieneAdeudo,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("acreditaciones")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.acreditaciones.title"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.acreditaciones &&
                                _vm.expediente.acreditaciones.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelAcreditaciones()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.expediente.acreditaciones &&
                                _vm.expediente.acreditaciones.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-danger",
                                          disabled: _vm.botonPdfDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.generarVisualizarPdfAcreditaciones()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "file-earmark-pdf" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.GenerarPdf")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("agreditaciones", {
                          attrs: { item: _vm.expediente.acreditaciones },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("participaciones")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.participaciones.evaluador.title"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.participacionesEvaluador &&
                                _vm.expediente.participacionesEvaluador.length >
                                  0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelParticipacionesComoEvaluador()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("participaciones-como-evaluador", {
                          attrs: {
                            item: _vm.expediente.participacionesEvaluador,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("historicoPagos")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.historicoPagos.title"
                          ),
                        },
                      },
                      [
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "header",
                                { staticClass: "bx-header-title mt-2" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bolder text-rizoma h3",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.persona.expediente.historicoPagos.title"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-right" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "outline-success",
                                            disabled: _vm.botonExcelDisabled,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.descargarReporteExcel()
                                            },
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: {
                                              icon: "file-earmark-spreadsheet",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("entity.action.export1")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: _vm.showPdfHistoricoPagos
                                              ? "secondary"
                                              : "outline-danger",
                                            disabled:
                                              _vm.showPdfHistoricoPagos ||
                                              _vm.botonPdfHistoricoPagosDisabled,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.abrirModalPdfHistoricoPagos()
                                            },
                                          },
                                        },
                                        [
                                          _vm.showPdfHistoricoPagos
                                            ? [
                                                _c("b-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    icon: "stopwatch",
                                                    animation: "spin",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.process.search.searching"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            : [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "file-earmark-pdf",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "entity.action.DescargarPdf"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-modal",
                                {
                                  attrs: {
                                    title: "Descargar PDF por periodo",
                                    "hide-footer": "",
                                    centered: "",
                                  },
                                  model: {
                                    value: _vm.modalPdfHistoricoPagosVisible,
                                    callback: function ($$v) {
                                      _vm.modalPdfHistoricoPagosVisible = $$v
                                    },
                                    expression: "modalPdfHistoricoPagosVisible",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Año" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.aniosDisponibles,
                                        },
                                        on: { change: _vm.onChangeAnio },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    {
                                                      attrs: {
                                                        value: "",
                                                        disabled: "",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "entity.action.selectyear"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3751835174
                                        ),
                                        model: {
                                          value: _vm.anioSeleccionado,
                                          callback: function ($$v) {
                                            _vm.anioSeleccionado = $$v
                                          },
                                          expression: "anioSeleccionado",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "btn-pdf-completo mr-3 mt-3",
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-danger",
                                          },
                                          on: {
                                            click: _vm.descargarPdfCompleto,
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: { icon: "file-earmark-pdf" },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "entity.action.DescargarAños"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Mes" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "border rounded p-2",
                                          staticStyle: {
                                            "max-height": "180px",
                                            overflow: "auto",
                                          },
                                        },
                                        [
                                          _c("b-form-checkbox-group", {
                                            attrs: {
                                              options: _vm.mesesDisponibles,
                                              stacked: "",
                                              disabled: !_vm.anioSeleccionado,
                                            },
                                            model: {
                                              value: _vm.mesesSeleccionados,
                                              callback: function ($$v) {
                                                _vm.mesesSeleccionados = $$v
                                              },
                                              expression: "mesesSeleccionados",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-2 d-flex" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "outline-secondary",
                                                disabled:
                                                  !_vm.anioSeleccionado ||
                                                  _vm.mesesDisponibles
                                                    .length === 0,
                                              },
                                              on: {
                                                click:
                                                  _vm.seleccionarTodosMeses,
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "entity.action.checkAll"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "ml-2",
                                              attrs: {
                                                size: "sm",
                                                variant: "outline-secondary",
                                                disabled: !_vm.anioSeleccionado,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.mesesSeleccionados = []
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "entity.action.clean"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-end pr-4 mt-5",
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-pdf-completo mr-3",
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-secondary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.modalPdfHistoricoPagosVisible = false
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("entity.action.cancel")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn-pdf-completo mr-3",
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-danger",
                                          },
                                          on: {
                                            click: _vm.confirmarPdfPorPeriodo,
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: { icon: "file-earmark-pdf" },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "entity.action.GenerarPdf"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-overlay",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    show: _vm.showPdfHistoricoPagos,
                                    rounded: "sm",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "overlay",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center px-3",
                                              },
                                              [
                                                _c("b-icon", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    icon: "stopwatch",
                                                    "font-scale": "2",
                                                    animation: "cylon",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _vm._v(
                                                      "Operacion en proceso…"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    899479252
                                  ),
                                },
                                [
                                  _c("b-table", {
                                    staticClass: "text-nowrap",
                                    attrs: {
                                      responsive: "",
                                      borderless: "",
                                      "show-empty": "",
                                      small: "",
                                      "current-page": _vm.currentPage,
                                      "sort-direction": "asc",
                                      items: _vm.historicoPagos,
                                      fields: _vm.fields,
                                      "thead-class": "custom-header",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("b-pagination", {
                                    attrs: {
                                      "total-rows": _vm.totalRows,
                                      "per-page": _vm.perPage,
                                      align: "center",
                                      size: "sm",
                                      pills: "",
                                      "head-variant": "primary",
                                    },
                                    on: { change: _vm.handlePageChange },
                                    model: {
                                      value: _vm.currentPage,
                                      callback: function ($$v) {
                                        _vm.currentPage = $$v
                                      },
                                      expression: "currentPage",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("ayudantias")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.ayudantias.subtitle"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.ayudantias &&
                                _vm.expediente.ayudantias.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelAyudantias()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("ayudantias", {
                          key: _vm.ayudantiasKey,
                          attrs: { item: _vm.expediente.ayudantias },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("mis-ayudantes")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.misAyudantes.subtitle"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.misAyudantes && _vm.misAyudantes.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelMisAyudantes()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("mis-ayudantes", {
                          attrs: { item: _vm.misAyudantes },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSection("cuentas")
                  ? _c(
                      "collapse-item",
                      {
                        attrs: {
                          visible: _vm.visible,
                          title: _vm.$t(
                            "apeironGwApp.persona.expediente.cuentas.title"
                          ),
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _vm.expediente.cuentasBancarias &&
                                _vm.expediente.cuentasBancarias.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.descargarReporteExcelCuentasBancarias()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "file-earmark-spreadsheet",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.export1")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.expediente.cuentasBancarias &&
                                _vm.expediente.cuentasBancarias.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-danger",
                                          disabled: _vm.botonPdfDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.generarVisualizarPdfCuentasBancarias()
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "file-earmark-pdf" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("entity.action.GenerarPdf")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("cuentas-bancarias", {
                          attrs: { item: _vm.expediente.cuentasBancarias },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.expediente && _vm.expedientesEncontrados.length === 0
          ? _c(
              "div",
              [
                _c("message", {
                  attrs: {
                    variant: _vm.variant,
                    title: "Buscador de expediente persona",
                    description: _vm.mensaje,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("visualizador-pdf", {
        attrs: {
          id: "visualizador-pdf",
          contenidoBase64: _vm.contenidoBase64,
          mostrar: _vm.pdfReady,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }